module.exports = __webpack_public_path__ + "static/media/teja.0036d9e1.png";